import Transform from '@ember-data/serializer/transform';

export default class NegativeToPositiveTransform extends Transform {
  serialize(deserialized: number): number {
    return -deserialized;
  }

  deserialize(serialized: number): number {
    return Math.abs(serialized);
  }
}

declare module 'ember-data/types/registries/transform' {
  export default interface TransformRegistry {
    'negative-to-positive': NegativeToPositiveTransform;
  }
}
